import { CloudCommand } from "../types.js";

export const getInfosFromUrls: CloudCommand = {
    action: "PROFILE_URLS/GET_INFOS",
    commandName: "profile.getInfosFromUrls",
    buildPayload: ({ profileURLs }) => ({ profileURLs }),
};
